import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createJazelVuetify } from '@jazel/jazel-vuetify'

export default createJazelVuetify({
  // keep legacy class for any scoped CSS, add unified class
  appClass: 'jzl-admin micro-srp',
})
